import { FieldArray, Form, Formik } from "formik";
import * as Yup from "yup";
import React, { useRef } from "react";
import { FormControl } from "@mui/material";
import { Box, Typography } from "@mui/material";
import profileImage from "../../../../src/profileImage.jpeg";
import { useNavigate } from "react-router-dom";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import ProfileImagePreview from "../../../componenets/FormikReusable/ProfileImagePreview";
import FormikControl from "../../../componenets/FormikReusable/FormikControl";

const VoterForm = () => {
  const navigate = useNavigate();
  const initialValues = {
    email: "",
    fullname: "",
    contactnumber: "",
    address: [
      {
        street: "",
        city: "",
        zipcode: "",
        state: "",
      },
    ],
    age: "",
    voterId: "",
    identityId: "",
    panId: "",
    file: null,
  };

  const validationSchema = Yup.object({
    email: Yup.string().required().email("Invalid Email Format"),
    fullname: Yup.string().required(),
    contactnumber: Yup.number().required().min(10),
    address: Yup.array().of(
      Yup.object().shape({
        zipcode: Yup.number().required("Required").min(6),
        street: Yup.string().required("Required").min(2),
        city: Yup.string().required("Required").max(100),
        state: Yup.string().required("Required"),
      })
    ),
    age: Yup.number()
      .positive("age must be greater than zero")
      .typeError("age must be a number")
      .required(),
    voterId: Yup.number().when("age", {
      is: (age) => age >= 18,
      then: () =>
        Yup.string()
          .required("Enter VoterId !! ")
          .matches(/^[A-Z]{4}[0-9]{8}$/, { message: "Invalid Voter ID !!" }),
    }),
    //IDNN12345678
    identityId: Yup.number().when("age", {
      is: (age) => age >= 5,
      then: () =>
        Yup.string()
          .required("Enter Identity Card !! ")
          .matches(/^[A-Z]{3}[0-9]{10}$/, {
            message: "Invalid Identity Card Number!!",
          }),
    }),
    //IDN1234567894
    panId: Yup.number().when("age", {
      is: (age) => age >= 18,
      then: () =>
        Yup.string()
          .required("Enter Pan card Number !! ")
          .matches(/^[A-Z]{4}[0-9]{8}$/, {
            message: "Invalid Pan Card Number!!",
          }),
    }),
    //IDNN12345678
    file: Yup.mixed()
      .nullable()
      .test(
        "fileSize",
        "This file is too large",
        (file) =>
          //1kb = 1024bytes //1mb = 1024kb
          !file || (file && file.size <= 1024 * 1024)
      )
      .test(
        "fileType",
        "Only the .jpeg, .jpg, .png format file accpeted",
        (file) =>
          !file || ["image/png", "image/jpg", "image/jpeg"].includes(file?.type)
      ),
  });
  const onSubmit = (values) => {
    console.log("Form Data", values);
    navigate("/projects/3/datadisplay", { state: values });
  };
  const fileref = useRef(null);

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        validateOnMount
      >
        {(formik) => {
          return (
            <div
              className="container shadow m-auto mt-5"
              style={{ border: "1px solid black", padding: "20px" }}
            >
              <h1>Registration Form with Yup Validation</h1>
              <Form>
                <div className="container ">
                  <div
                    className="profile-pic "
                    style={{ paddingLeft: "450px" }}
                  >
                    {formik.values.file ? (
                      <ProfileImagePreview file={formik.values.file} />
                    ) : (
                      <img
                        src={profileImage}
                        height="200"
                        width="200"
                        style={{ cursor: "pointer", borderRadius: "50%" }}
                      />
                    )}
                    <button
                      type="button"
                      onClick={() => fileref.current.click()}
                    >
                      Upload
                    </button>
                    <input
                      ref={fileref}
                      type="file"
                      hidden
                      onChange={(e) =>
                        formik.setFieldValue("file", e.target.files[0])
                      }
                    />

                    {formik.errors.file ? (
                      <p style={{ color: "red" }}> {formik.errors.file} </p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="row ">
                    <div className="col-sm">
                      <FormikControl
                        control="input"
                        type="text"
                        label="FullName"
                        name="fullname"
                      />
                    </div>
                    <div className="col-sm">
                      <FormikControl
                        control="input"
                        type="email"
                        label="Email"
                        name="email"
                      />
                    </div>
                    <div className="col-sm">
                      <FormikControl
                        control="input"
                        type="text"
                        label="ContactNumber"
                        name="contactnumber"
                      />
                    </div>
                  </div>

                  <div className="row " style={{ padding: "20px" }}>
                    <FieldArray name="address">
                      {(fieldArrayProps) => {
                        const { push, remove, form } = fieldArrayProps;
                        const { values } = form;
                        const { address } = values;
                        console.log("errors", form.errors);

                        return (
                          <>
                            <div className="container">
                              <button
                                type="button"
                                onClick={() =>
                                  push({
                                    street: "",
                                    city: "",
                                    zipcode: "",
                                    state: "",
                                  })
                                }
                              >
                                {" "}
                                <AddCircleIcon />{" "}
                              </button>

                              {address.map((curr, index) => {
                                return (
                                  <>
                                    <div>
                                      <div key={index}>
                                        <div class="row">
                                          <div className="col-sm">
                                            <FormikControl
                                              control="input"
                                              type="text"
                                              label="Street"
                                              name={`address[${index}.street]`}
                                            />
                                          </div>
                                          <div className="col-sm">
                                            <FormikControl
                                              control="input"
                                              type="text"
                                              label="city"
                                              name={`address[${index}.city]`}
                                            />
                                          </div>
                                          <div className="col-sm">
                                            <FormikControl
                                              control="input"
                                              type="number"
                                              label="zipcode"
                                              name={`address[${index}.zipcode]`}
                                            />
                                          </div>
                                          <div className="col-sm">
                                            <FormikControl
                                              control="input"
                                              type="text"
                                              label="state"
                                              name={`address[${index}.state]`}
                                            />
                                          </div>
                                          <div className="col-sm">
                                            {index > 0 ? (
                                              <button
                                                type="button"
                                                onClick={() => remove(index)}
                                              >
                                                {" "}
                                                <RemoveCircleOutlineIcon />{" "}
                                              </button>
                                            ) : null}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          </>
                        );
                      }}
                    </FieldArray>
                  </div>

                  <div className="row">
                    <div className="col-sm">
                      <FormikControl
                        control="input"
                        type="number"
                        label="age"
                        name="age"
                      />
                    </div>
                    <div className="col-sm">
                      <FormikControl
                        control="input"
                        type="text"
                        label="voterId"
                        name="voterId"
                      />
                    </div>
                    <div className="col-sm">
                      <FormikControl
                        control="input"
                        type="text"
                        label="IdentityID"
                        name="identityId"
                      />
                    </div>
                    <div className="col-sm">
                      <FormikControl
                        control="input"
                        type="text"
                        label="PANID"
                        name="panId"
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  style={{ margin: "10px" }}
                  disabled={!(formik.isValid || formik.isSubmitting)}
                >
                  Submit
                </button>
                <button
                  type="button"
                  style={{ margin: "10px" }}
                  disabled={!formik.dirty}
                  onClick={() => {
                    formik.resetForm();
                  }}
                >
                  Reset
                </button>
              </Form>
            </div>
          );
        }}
      </Formik>
    </>
  );
};

export default VoterForm;
